export default "__VITE_ASSET__B$IPixHK__"